
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";

import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

export default function RedirectAddress() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Feature',
            url: '/dashboard/Feature'
        },
        {
            name: 'ریداریکت آدرس',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="text-left  bg-white  p-3 m-4    h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="ریداریکت آدرس"></HeaderOfPage>


                <div className="grid grid-cols-1 gap-4">
                    <div className="directions ">
                        <NewRedirect reloaditem={reloadgame}></NewRedirect>
                    </div>
                    <div className="directions">
                        <ListofBlog key={key}></ListofBlog>
                    </div>
                </div>
            </div>

        </>
    )
}
function ListofBlog() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);

    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [page, setPage] = useState<any>(1);

    const getalldata = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/redirect?page=' + page,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            //let mydata = res.data;
            //  console.log(config.url + '/v1/dashboard/bloggroup')
            setList(res.data.message);
        } catch (error: any) {

            // error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }
    const deleted = async (id: any) => {

        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/redirect/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata();
                } catch (error) {
                    console.log(error);
                }
            }
        });

    }
    useEffect(() => {
        getalldata();
    }, [page]);
    return (
        <div>


            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle text-left" dir="ltr">
                        <div className="overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200 ">
                                <thead>
                                    <tr>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('مبدا')}  </th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('مقصد')}</th>
                                        {/* <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('Articles')} </th> */}
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase  ">{t('Action')} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list != null && list.docs.map((item: any) => {
                                        return (
                                            <tr className="odd:bg-white even:bg-gray-100 hover:bg-gray-100 ">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 ">{item.startaddress}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 ">{item.endaddressaddress}</td>
                                                {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 ">Show Articles</td> */}

                                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex gap-2">
                                       
                                                    <button
                                                        onClick={(e) => { deleted(item.id) }}
                                                        type="button"
                                                        className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    >
                                                        <img src="/icons/delred.svg" width={20} alt="Del" />


                                                    </button>
                                                </td>

                                            </tr>
                                        )
                                    })}



                                </tbody>
                            </table>
                        </div>
                        
                             <div className="mt-4">
                                <nav className="flex items-center -space-x-px" aria-label="Pagination">
                                    {list != null && list.prevPage != null &&
                                        <button
                                            onClick={(e) => { setPage(list.prevPage) }}
                                            type="button" className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none" aria-label="Previous">
                                            <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="m15 18-6-6 6-6"></path>
                                            </svg>
                                            <span className="hidden sm:block">{t('Previous')} </span>
                                        </button>
                                    }
                                    {list != null &&
                                        Array.from({ length: list.totalPages }, (_, index) => index + 1).map((item) => {
                                            return (
                                                list.page == item ?
                                                    <button type="button" className="min-h-[38px] min-w-[38px] flex justify-center items-center bg-gray-200 text-gray-800 border border-gray-200 py-2 px-3 text-sm first:rounded-s-lg last:rounded-e-lg focus:outline-none focus:bg-gray-300 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-600 dark:border-neutral-700 dark:text-white dark:focus:bg-neutral-500" aria-current="page">{item}</button>

                                                    :
                                                    <button
                                                       onClick={(e) => { setPage(item) }}
                                                        type="button" className="min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 hover:bg-gray-100 py-2 px-3 text-sm first:rounded-s-lg last:rounded-e-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none">{item}</button>
                                            )

                                        })
                                    }

                                    {list != null && list.nextPage != null &&
                                        <button
                                            onClick={(e) => { setPage(list.nextPage) }}
                                            type="button" className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none " aria-label="Next">
                                            <span className="hidden sm:block">{t('Next')}</span>
                                            <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="m9 18 6-6-6-6"></path>
                                            </svg>
                                        </button>
                                    }
                                </nav>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
function NewRedirect({ reloaditem }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [data, setData] = useState<any>({
        startaddress: '',
        endaddressaddress: '',
        

    });
    const [error, setError] = useState(null);
    const [key, setKey] = useState(1);

    const save = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/redirect',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;
            reloaditem();
            let x = key + 1;
            setKey(x);
            return mydata;
        } catch (error: any) {

            error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    return (
        <div className="text-right bg-black rounded-[10px] p-5" dir="rtl">


            <form key={key}>
                <div className=" space-y-3">
                    <label className="text-white"> {t('Name')} </label>
                    <input
                        dir="ltr"
                        type="text"
                        className={`${inputstyle}     ${error != null && error['startaddress'] != undefined && `bg-red-100`} `}
                        placeholder="Name"
                        onChange={(e) => setData({ ...data, startaddress: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['startaddress']['message']}</small>}
                </div>
                <div className=" space-y-3 mt-4">
                    <label className="text-white"> Slug </label>
                    <input
                        dir="ltr"

                        type="text"
                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                        placeholder="Slug"
                        onChange={(e) => setData({ ...data, endaddressaddress: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['endaddressaddress']['message']}</small>}
                </div>

                <div className="max-w-sm space-y-3 mt-4">
                    <button type="button"
                        onClick={(e) => { save() }}
                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                    >
                        {t('اضافه کردن ریداریکت آدرس')}
                    </button>

                </div>
            </form>
        </div>
    )
}